<template>
  <div>

    <div class="row">
      <account-card :user="account" @saved="account.company ? loadUsers() : ''" />
    </div>

    <transition-group name="el-fade-in-linear" mode="out-in">
      <div key="COMPANY" v-if="account && account.company && !$store.state.isIndividual" class="row">
        <div class="card" v-loading="loadingCompany" element-loading-spinner="qc-spinner">
          <div class="card-header">
            <h4 class="card-title">Organisation</h4>
            <p class="category">Your organisation details and settings</p>
          </div>
          <div class="card-content">
            <div class="form-horizontal" data-vv-scope="company-form">
              <dynamic-input label="Organisation name" name="companyname" :validations="{required: true}" v-model="account.company.name" :readOnly="!$store.state.admin" />
              <!--
              <dynamic-input label="Street address" name="street1" :validations="{required: true}" v-model="account.company.addressStreet1" :readOnly="!$store.state.admin" />
              <dynamic-input label=" " name="street2" v-model="account.company.addressStreet2" :readOnly="!$store.state.admin" />
              <dynamic-input label=" " name="stree3" v-model="account.company.addressStreet3" :readOnly="!$store.state.admin" />
              <dynamic-input label="City" name="City" :validations="{required: true}" v-model="account.company.addressCity" :readOnly="!$store.state.admin" />
              <dynamic-input label="Post code" name="postcode" :validations="{required: true}" v-model="account.company.addressPostCode" :readOnly="!$store.state.admin" />
              -->

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Country <span v-if="$store.state.admin" class="text-danger">*</span>
                </label>
                <div class="col-sm-10" :class="{'form-control-static':!$store.state.admin}">
                  <country-select v-if="$store.state.admin" v-model="account.company.addressCountry" />
                  <span v-else>{{account.company.addressCountry.name}}</span>
                </div>
              </div>
              
              <dynamic-input v-if="account.company.addressCountry.vat" label="VAT ID" name="vatid" v-model="account.company.vatId" :readOnly="!$store.state.admin" :description="account.company.addressCountry.id != 'GB' ? 'Due to VAT charging rules in your country, if you do not enter a VAT number you will be charged VAT.' : null" />
            
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Industry <span v-if="$store.state.admin" class="text-danger">*</span>
                </label>
                <div class="col-sm-10" :class="{'form-control-static':!$store.state.admin}">
                  <industry-select v-if="$store.state.admin" v-model="account.company.industry" />
                  <span v-else>{{account.company.industry.name}}</span>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">Restricted User View</label>
                <div class="col-sm-10">
                  <p class="form-control-static" v-if="$store.state.admin"><p-switch v-model="account.company.restrictedUserView" on-text="On" off-text="Off"></p-switch></p>
                  <p class="form-control-static" v-else>{{account.company.restrictedUserView ? 'On' : 'Off'}}</p>
                  <span class="help-block">By default, all users under a company account will have access to all verifications processed by all other users. With restricted user view on, users will only have access to verifications processed by themselves. Admin users under the company account will continue to have access to all verifications.</span>
                </div>
              </div>

              <div v-if="account.company.callbackEmail" class="form-group">
                <label class="col-sm-2 control-label">Central Notification Email Address</label>
                <div class="col-sm-10">
                  <p class="form-control-static">{{account.company.callbackEmail}}</p>
                  <span class="help-block">By default, notification emails regarding verification progress are sent to the user who submitted the verification (if enabled above). This Central Notification Email Address will instead recieve all notification emails regarding all verifications and submitting users will not be emailed.</span>
                </div>
              </div>

            </div>
          </div>
          <div v-if="$store.state.admin" class="card-footer row">    
            <div class="col-md-12">
              <button @click="saveCompany" class="btn btn-fill btn-wd pull-right" v-bind:disabled="!companySavable" v-bind:class="{'btn-disabled': !companySavable}"><span class="btn-label"><i class="fa fa-floppy-o"></i></span>&nbsp;Save</button>
            </div>
          </div>
        </div>
      </div>

      <div key="USERS" v-if="account && (account.company || account.institute) && !$store.state.isIndividual" class="row">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Users</h4>
            <div class="category">Your {{account.company ? 'organisation' : 'institute'}} users</div>
          </div>
          <div class="card-content">
            <div >
              <el-table class="table table-striped table-no-bordered table-hover"
                ref="userTable"
                :data="users"
                v-loading="loadingUsers"
                element-loading-spinner="qc-spinner"
                style="width: 100%"
                tooltip-effect="light">
                <el-table-column :min-width="25" :show-overflow-tooltip="true" label="First Name">
                  <template slot-scope="props">
                    <span>{{props.row.firstname}} <span v-if="props.row.username === account.username">(you)</span></span>
                  </template>
                </el-table-column>
                <el-table-column :min-width="25" label="Last Name">
                  <template slot-scope="props">
                    <span>{{props.row.lastname}} <span v-if="props.row.username === account.username">(you)</span></span>
                  </template>
                </el-table-column>
                <el-table-column :min-width="50" :show-overflow-tooltip="true" label="Username">
                  <template slot-scope="props">
                    <span>{{props.row.username}}</span>
                    <span v-if="canEdit(props.row)" class="pull-right" style="z-index: 9000">
                      <a class="btn btn-simple btn-info btn-xs btn-icon btn-warning" @click.prevent="editUser(props.row)"><i class="fa fa-pencil"></i></a>
                      <a class="btn btn-simple btn-info btn-xs btn-icon btn-danger" @click.prevent="deleteUser(props.row)"><i class="fa fa-trash"></i></a>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column :width="220" align="right" label="">
                  <template slot-scope="props">
                    <span v-if="props.row.pending" class="label label-wd label-plain"><i class="fa fa-clock-o"></i>Pending</span>
                    <span v-else-if="props.row.admin" class="label label-wd label-plain"><i class="fa fa-user-plus"></i>Admin</span>
                    <span v-else class="label label-wd label-plain"><i class="fa fa-user"></i>User</span>
                    <span v-for="role in props.row.customRoles" :key="role" class="label label-wd label-plain">{{role}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-if="$store.state.admin" class="card-footer row">    
            <div class="col-md-12">
              <button @click="addUser" class="btn btn-fill btn-wd pull-right"><span class="btn-label"><i class="fa fa-plus"></i></span>&nbsp;Add a user</button>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>


<script>
  import IndustrySelect from 'src/components/Inputs/IndustrySelect'
  import CountrySelect from 'src/components/Inputs/CountrySelect'
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import PSwitch from 'src/components/Switch.vue'

  import AccountCard from './components/AccountCard'
  import RegisterUserCard from './components/RegisterUserCard'
  import ModalMessage from 'src/components/ModalPlugin/ModalMessage'
  import ModalOptions from 'src/components/ModalPlugin/ModalOptions'

  export default {
    name: "account",
    components: {
      IndustrySelect,
      CountrySelect,
      DynamicInput,
      AccountCard,
      RegisterUserCard,
      ModalMessage,
      PSwitch
    },
    data () {
      return {
        account: {},
        users: [],
        loadingCompany: true,
        loadingUsers: true
      }
    },
    mounted () {
      this.$api.getAccount()
        .then(response => {
          this.account = response.data
          if(this.account.company || this.account.institute) {
            this.loadUsers()
          }
          this.loadingCompany = false
        }).catch(error => {
          console.log(error)
        })
    },
    computed: {
      companySavable() {
        return !this.loadingCompany && !this.$validator.errors.any()
      }
    },
    methods: {
      loadUsers() {
        this.loadingUsers = true
        this.$api.getUsers(null, true)
          .then(response => {
            this.users = response.data
            this.loadingUsers = false
          })
          .catch(error => {
            this.loadingUsers = false
            console.log(error)
          })
      },
      canEdit(user) {
        if(!this.$store.state.admin) {
          return false
        }
        if(this.account.username === user.username) {
          return false
        }
        if(user.pending) {
          return false
        }
        return true
      },
      editUser(row, oldRow) {
        if(this.$store.state.admin) {
          if(row) {
            if(this.account.username === row.username) {
              this.$modal.show(ModalMessage,
                {
                  title: "Yourself",
                  message: "This is you, please edit your own details in the account section above.",
                  closeText: "Ok"
                })
            } else if(row.pending) {
              this.$modal.show(ModalMessage,
                {
                  title: "Pending",
                  message: "This user has yet to complete their registration. Click below if you wish to resend their registration link to their email.",
                  closeText: "Cancel",
                  actionText: "Resend",
                  action: () => 
                    {
                      this.$api.addUser(row)
                        .then(response => {
                          this.$snotify.success("Email resent", "Success")
                          this.$modal.close()
                        })
                      .catch(error => {
                          this.$snotify.error("Email NOT resent, please contact support.", "Error", {
                            timeout: 7500
                          })
                        console.log(error)
                        this.$modal.close()
                      })
                    }
                })
            } else {
              this.$modal.show(AccountCard,
                {
                  title: "User",
                  description: null,
                  user: row,
                  self: false,
                  customRolesLabel: this.account.customRolesLabel,
                  assignableCustomRoles: this.account.assignableCustomRoles
                },
                {
                  saved: () => {
                    this.loadUsers()
                    this.$modal.close()
                  },
                  deleteUser: () => {
                    this.$modal.close()
                    this.deleteUser(row)
                  },
                  close: () => {
                    this.loadUsers()
                    this.$modal.close()
                  }
                }
              )
            }
            this.$refs['userTable'].setCurrentRow()
          }
        }
      },
      saveCompany() {
        this.$validator.validateAll('company-form').then((result) => {
          if(result) {
            this.loadingCompany = true
            this.$api.updateCompany({
              name: this.account.company.name,
              addressStreet1: this.account.company.addressStreet1,
              addressStreet2: this.account.company.addressStreet2,
              addressStreet3: this.account.company.addressStreet3,
              addressCity: this.account.company.addressCity,
              addressPostCode: this.account.company.addressPostCode,
              addressCountry: this.account.company.addressCountry,
              industry: this.account.company.industry,
              vatId: this.account.company.vatId,
              restrictedUserView: this.account.company.restrictedUserView
            })
            .then(response => {
              this.account.company = response.data
              this.loadingCompany = false
              this.$snotify.success("Your company details have been updated.", "Success")
            })
            .catch(error => {
              console.log(error)
              this.loadingCompany = false
            })
          }
        })
      },
      addUser() {
        this.$modal.show(RegisterUserCard,
          {
            title: "New User",
            description: this.account.company ? "New users will be able to submit and review verification requests under your company account" : "New users will be able review and resolve pending verifications as well as submit new requests on behalf of your institute",
            companyId: this.account.company ? this.account.company.id : null,
            instituteId: this.account.institute ? this.account.institute.id : null,
            self: false,
            customRolesLabel: this.account.customRolesLabel,
            assignableCustomRoles: this.account.assignableCustomRoles
          },
          {
            saved: () => {
                this.loadUsers()
                this.$modal.close()
              },
            close: () => {
              this.loadUsers()
              this.$modal.close()
            }
          }
        )
      },
      deleteUser(user) {
        this.$modal.show(ModalOptions,
          {
            title: "Delete User",
            message: "Are you sure you want to delete " + user.username + "?",
            closeText: "Cancel",
            actionText1: "Delete",
            actionIcon1: "fa fa-trash",
            action1: () => 
            {
                this.$api.deleteUser(user.username)
                  .then(response => {
                    this.loadUsers()
                    this.$modal.close()
                    this.$snotify.success("User " + user.username + " has been deleted.", "Success")
                  })
                  .catch(error => {
                    console.log(error)
                    this.$modal.close()
                  })
              }
            }
          )
      },
    }
  }
</script>